import { GridListTile } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const WrapperGrid = styled(GridListTile)`
  ${({ active }) => css`
    height: 100%;
    overflow: hidden;
    .MuiListItemText-root {
      margin-top: 0.25px;
      margin-bottom: 0.25px;
    }
  `}
`;

export const WrapperCharts = styled.div`
  ${({ charts }) => css`
    display: grid;
    grid-template-columns: repeat(${charts}, minmax(0, 1fr));
    justify-content: ${charts === 1 ? 'center' : 'stretch'};
    justify-items: ${charts === 1 ? 'center' : 'stretch'};
    gap: 0.55rem;
    width: 100%;
    height: 100%;
  `}
`;

export const ChartCard = styled.div`
  background: linear-gradient(180deg, #fbfbfc 0%, #f1f2f4 100%);
  border: 1px solid #dfe2e6;
  border-radius: 0;
  padding: 0.45rem 0.35rem 0.55rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  height: 100%;
  min-height: 0;
  width: 100%;
  max-width: 84px;
`;

export const ChartHeader = styled.div`
  color: ${({ color = '#245f94' }) => color};
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.06em;
`;

export const Chart = styled.div`
  ${({ value, max, color, opacity }) => css`
    height: 100%;
    width: 100%;
    min-height: 136px;
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      background: linear-gradient(180deg, #ffffff 0%, #eef3f7 100%);
      border-radius: 0.5rem;
      position: relative;
      width: 100%;
      height: 100%;
      flex: 1;
      padding: 0.25rem;
      box-shadow: inset 0 0 0 1px rgba(18, 50, 74, 0.08);

      &:after {
        content: '';
        opacity: ${opacity ? 0.55 : 1};
        position: absolute;
        bottom: 0.25rem;
        left: 0.25rem;
        width: calc(100% - 0.5rem);
        height: ${max ? Math.max(((value * 100) / max).toFixed(2), 0) : 0}%;
        max-height: calc(100% - 0.5rem);
        background: ${color ?? '#dc004e'};
        border-radius: 0.38rem;
      }
    }
  `}
`;

export const ChartFooter = styled.div`
  text-align: center;
`;

export const ChartValue = styled.div`
  color: #12324a;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.1;
`;

export const ChartLabel = styled.div`
  color: #6b8395;
  font-size: 0.72rem;
  font-weight: 600;
  margin-top: 0.12rem;
`;

export const HighlightValue = styled.span`
  color: #dc004e;
  font-weight: 800;
`;
